import React from 'react';

import { SupportCard } from '@opendoor/cinderblocks/buy/SupportCard';

/**
 * Customer Card Contact Card for Buy Direct Checkout
 * storybook-check-ignore
 */
export const CustomerCareContactCard = React.memo(() => {
  return (
    <SupportCard
      analyticsName="buy-direct-checkout-support-card"
      contact={{
        name: 'Customer Care Associate',
        email: 'exclusive@opendoor.com',
        title: 'Contact us with any questions you have about this home',
        phoneNumber: '512-706-9938',
        photoUrl: '',
      }}
    />
  );
});

CustomerCareContactCard.displayName = 'BuyDirectCustomerCareContactCard';
